/**
 * `transport` — the ways there, or the ways back.
 *
 * **Dormant: nothing emits this yet.** It stays in the catalogue rather than
 * being deleted, because the tool behind it (`how_to_get_there`) exists and the
 * direction is part of the answer: the museum publishes ONE list describing both
 * ways, and a card pointing the wrong way is the half a visitor taps.
 *
 * No fare is printed — the museum publishes none, and composing one is exactly
 * what the graph's grounding belts exist to cut.
 */

import type { TransportCardProps } from '../generated/schemas';
import { send } from '../../lib/send';
import { stripEmoji as plain } from '../../lib/emoji';
import { useSendLocked } from '../../chat/turnLock';

export default function TransportCard({ props }: { props: TransportCardProps }) {
  const sendLocked = useSendLocked();
  return (
    <article className="card card--transport">
      <header className="card__head">
        <h3 className="card__title">
          {props.direction === 'from' ? 'Как уехать обратно' : 'Как добраться'}
        </h3>
      </header>
      <ul className="rows">
        {props.options.map((option, index) => (
          <li key={`${option.mode ?? option.label}:${index}`} className="rows__item">
            <div className="rows__body">
              <span className="rows__title">{plain(option.label)}</span>
              {option.duration ? <span className="rows__date">{plain(option.duration)}</span> : null}
              {option.note ? <span className="rows__sub">{plain(option.note)}</span> : null}
            </div>
            {option.url ? (
              <a
                className="chip chip--link"
                href={option.url}
                target="_blank"
                rel="noreferrer noopener"
              >
                Маршрут
              </a>
            ) : (
              <button
                type="button"
                className="chip"
                disabled={sendLocked}
                onClick={() =>
                  send(
                    props.direction === 'from'
                      ? `Как уехать на «${option.label}» из Петергофа?`
                      : `Как добраться на «${option.label}» до Петергофа?`,
                  )
                }
              >
                Подробнее
              </button>
            )}
          </li>
        ))}
      </ul>
    </article>
  );
}
